import React from 'react';
import { Avatar, Box, Grid, Tooltip, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { fDateTime } from '../../../utils/formatTime';
import { stringToPrimaryColor } from '../../../utils/cssStyles';
import OrderReviewerTooltipText from './order/OrderReviewerTooltipText';

ReviewColumnIcons.propTypes = {
	params: PropTypes.object,
	pending: PropTypes.bool,
}
export default function ReviewColumnIcons({ params, pending }) {

	return (
		<Grid container direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={1}>
			{params.row.reviews?.filter(r => r.reviewerName).map((r) =>
				<Grid item key={`${r.orderReviewerId}_${r.orderId}`}>
					<Tooltip arrow
						title={
							<Typography variant="caption">
								<Box component="span" sx={{ fontWeight: 'bold' }}> {r.reviewed
									? `${r.reviewerName} reviewed on ${fDateTime(r.reviewedDate)}`
									: pending ? `Awaiting ${r.reviewerName}'s review` : `${r.reviewerName} did not review`}</Box>
								<OrderReviewerTooltipText reviewer={r} department={params.row.department} />
							</Typography>
						}>
						<Avatar
							sx={
								{
									bgcolor: r.reviewed ? stringToPrimaryColor(r.reviewerName) : '#ffffff',
									color: r.reviewed ? '#ffffff' : stringToPrimaryColor(r.reviewerName),
									border: r.reviewed ? '' : '1px solid black',
									borderColor: r.reviewed ? '' : stringToPrimaryColor(r.reviewerName),
									width: 30,
									height: 30,
									fontSize: 14,
									fontWeight: 'regular',
								}
							}
							variant="rounded"
						>
							{r.reviewerName
								.toUpperCase()
								.split(' ')
								.map((n) => n[0])
								.join('')}
						</Avatar>
					</Tooltip>
				</Grid>
			)
			}
		</Grid >
	)
}
